import React from "react";
import propTypes from "prop-types";
import "./styles.scss";
import logo from "./assets/ey_logo.png";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { selectActionData, selectSettings } from "AuthorizeLink/selectors";
import { APP_TITLE } from "../../constants";
import HelpModal from "../HelpModal/index";
const mapStateToProps = state => {
  return {
    actionData: selectActionData(state),
    settings: selectSettings(state)
  };
};
class EYTopNavBar extends React.Component {
  static propTypes = {
    displayUser: propTypes.bool,
    actionData: propTypes.object,
    settings: propTypes.object
  };
  hidden = true;
  static defaultProps = {
    displayUser: true
  };
  constructor(props) {
    super(props);
    this.state = {
      helpModalFlag: false
    };
  }
  redirectToAccessLink = () => {
    window.location.reload();
  };
  showHelpModal = () => {
    const { helpModalFlag } = this.state;
    this.setState({ helpModalFlag: !helpModalFlag });
  };
  render() {
    const { displayUser, settings } = this.props;
    const { helpModalFlag } = this.state;
    return (
      <React.Fragment>
        <section className="hero is-dark is-large">
          <nav
            className="navbar is-dark sc-eHgmQL hrHzKm"
            role="navigation"
            aria-label="main navigation"
          >
            <div className="brand-nav" navbarbrand={true.toString()}>
              <img
                style={{ cursor: "default" }}
                src={logo}
                className="navbarbrand sc-iAyFgw cNgTOs"
              />
              <nav className="sc-cvbbAY bTbsLM">
                <a className="sc-brqgnP jfoSEU" style={{ cursor: "default" }}>
                  {APP_TITLE}
                </a>
              </nav>
            </div>
            {displayUser && (
              <div className="navbar-menu" id="navbarBasicExample">
                <div className="navbar-end">
                  <nav
                    className="sc-jWBwVP jPpuAy"
                    onClick={this.showHelpModal}
                  >
                    <a
                      className="sc-brqgnP jfoSEU"
                      target="_blank"
                      style={{
                        fontFamily: "Noto Sans",
                        color: "#FFFFFF",
                        fontSize: "14px"
                      }}
                    >
                      <FormattedMessage
                        id={
                          "components.layout.elements.MenuHeader.Container.Menu.help"
                        }
                      />
                    </a>
                  </nav>
                  {!this.hidden && (
                    <nav className="sc-jWBwVP jPpuAy">
                      <a
                        className="sc-brqgnP jfoSEU"
                        target="#"
                        style={{
                          fontFamily: "Noto Sans",
                          color: "#FFFFFF",
                          fontSize: "14px"
                        }}
                      >
                        {
                          <FormattedMessage
                            id={
                              "components.layout.elements.MenuHeader.Container.Menu.privacy"
                            }
                          />
                        }
                      </a>
                    </nav>
                  )}
                  {!this.hidden && (
                    <nav className="sc-jWBwVP jPpuAy">
                      <a
                        className="sc-brqgnP jfoSEU"
                        target="#"
                        style={{
                          fontFamily: "Noto Sans",
                          color: "#FFFFFF",
                          fontSize: "14px"
                        }}
                      >
                        {<FormattedMessage id={"topNav.signOut"} />}
                      </a>
                    </nav>
                  )}
                </div>
              </div>
            )}
          </nav>
        </section>
        <HelpModal onClose={this.showHelpModal} isOpen={helpModalFlag} />
      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps)(EYTopNavBar);
